class Badge {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-badge',
            targetValue: 'target'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$target = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.targetValue}"]`);
    }

    initialize () {
        if (this.$target) {
            this.setEvents();
            this.setMinSize(true);
        }
    }

    setMinSize (add) {
        if (add) {
            let min = this.$target.offsetHeight;

            if (this.$target.offsetWidth > min) {
                min = this.$target.offsetWidth;
            }

            this.$target.style.minWidth = `${min}px`;
            this.$target.style.minHeight = `${min}px`;
        } else {
            this.$target.style = '';
            this.setMinSize(true);
        }
    }

    setEvents () {
        window.addEventListener('resize', () => {
            this.setMinSize(false);
        });
    }
}

export { Badge };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$badge = $context.querySelectorAll('[data-badge="root"]');
        for (let i = 0; i < $$badge.length; i++) {
            const $badge = $$badge[i];

            const $badgeAPI = new Badge($badge);
            $badgeAPI.initialize();
        }
    }
});
